import { render, staticRenderFns } from "./button-confirm.vue?vue&type=template&id=85186df6"
import script from "./button-confirm.vue?vue&type=script&lang=js"
export * from "./button-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports